import { Component, Input, ViewEncapsulation } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Size } from 'ngx-spinner/lib/ngx-spinner.enum';

@Component({
  selector: 'bll-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LoaderComponent {
  @Input()
  get show(): any {
    return this._show;
  }
  set show(value: any) {
    this._show = coerceBooleanProperty(value);
    if (this._show) {
      this.spinner.show(this.name);
      return;
    }
    this.spinner.hide(this.name);
  }
  private _show: boolean;
  @Input()
  get fullscreen(): any {
    return this._fullscreen;
  }
  set fullscreen(value: any) {
    this._fullscreen = coerceBooleanProperty(value);
  }
  private _fullscreen: boolean;
  @Input() size: Size = 'default'; //TODO: typing
  @Input()
  set name(val: string) {
    this._name = val;
  }
  get name(): string {
    return this._name;
  }
  private _name: string;

  constructor(private spinner: NgxSpinnerService) {
    if (!this._name) {
      this._name = '_' + Math.random().toString(36).substr(2, 9);
    }
  }
}
